import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Paper,
} from '@mui/material';
import {
  BasicTable,
  Button,
  CardComponent,
  NoDataVisual,
  PageTitleAndSubTitle,
  SvgDeleteButton,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useStores } from '../../stores';
import { settingsMessages } from '../../core-utils/messages/settingspagemessages';
import { observer } from 'mobx-react';
import { UserAccessConstants } from '../../core-utils/helper-utils/userAccess';
import NewUserModal from '../../_components/organisms/NewUserModal';
import { formatEmployerGroupNameForTable, roleMap } from './helper';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  // formatAllScreens,
  formatScreensArray,
  getAllEmployerGroups,
  getRoleDisplayName,
  getRoleValue,
} from '../../core-utils/formatters/UserManagementPageFormatter';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import Snackbar from '../../_components/atoms/Snackbar';
import { RESET_PASSWORD } from '../../core-utils/routes';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import { Pagination } from '@mui/material';
import EditIcon from '../../_components/atoms/Icons/EditIcon';
import { toJS } from 'mobx';
import SvgClose from '@HomaHealth/ui-component-library/lib/_components/atoms/Icons/Close';
import DeleteConfirmation from '../../../public/Images/DeleteConfirmation.png';
import {
  SimpleSearch,
  TextWithIcon,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Restore from '@mui/icons-material/Restore';
import { DottedText } from '../../core-utils/helper-utils/financialForensicsHelper';
import { cellStyles1 } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import { formatDateTime } from '../../core-utils/helper-utils/helper';
// import TabSelection from '../../_components/molecules/TabSelection';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

const UserManagementPage = observer(() => {
  const groupsTableColumns: any[] = [
    {
      name: 'Action',
      align: 'center',
      cellStyles: cellStyles4,
      width: '50px',
    },
    {
      name: 'User Name',
      align: 'center',
      cellStyles: cellStyles4,
      width: '600px',
      colSpan: 2,
    },
    {
      name: 'Email',
      align: 'center',
      cellStyles: cellStyles4,
      width: '250px',
    },
    {
      name: 'Access Level',
      align: 'center',
      cellStyles: cellStyles4,
      width: '200px',
    },
    {
      name: 'Role',
      align: 'center',
      cellStyles: cellStyles4,
      width: '250px',
    },
    {
      name: 'Organization',
      align: 'center',
      cellStyles: cellStyles4,
      width: '250px',
    },
    {
      name: 'Groups',
      align: 'center',
      cellStyles: cellStyles4,
      width: '170px',
    },
    {
      name: 'Claims AIQ (Member Lives)',
      align: 'center',
      cellStyles: cellStyles4,
      width: '500px',
      colSpan: 2,
    },
    {
      name: 'Contracts AIQ (Doc Units)',
      align: 'center',
      cellStyles: cellStyles4,
      width: '500px',
      colSpan: 2,
    },
    {
      name: 'Care Navigation (Cases/Month)',
      align: 'center',
      cellStyles: cellStyles4,
      width: '500px',
      colSpan: 2,
    },
  ];

  const useStyles = makeStyles()({
    mainDiv: {
      backgroundColor: '',
      border: '',
      marginTop: '40px',
      marginLeft: '63px',
    },
    tableGrid: {
      marginTop: '11px',
      overflowX: 'auto',
      width: '1130px',
      ...scrollBarStyles,
    },
    tabledata: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    onHoverIcon: {
      height: '20px',
      width: '20px',
      cursor: 'pointer',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      padding: '24px 28px 40px 32px',
      backgroundColor: patientAccessTheme.palette.status.white,
      border: 'none !important',
      position: 'relative',
      outline: 'none',
    },
    upperGrid: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
    },
    menuItem: {
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
      color: patientAccessTheme.palette.text.mediumemphasis,
      padding: '8px 16px',
    },
    label: {
      fontSize: '14px',
      lineHeight: '12px',
      fontWeight: 500,
      color: patientAccessTheme.palette.text.mediumemphasis,
    },
    popup: {
      marginTop: '2.5rem',
    },
  });
  const { classes } = useStyles();

  const textWithIconStyles = {
    gap: '0.5rem',
    padding: '0.1rem',
    width: '100%',
  };
  const commanIconStyles = {
    height: '18px',
    width: '18px',
    cursor: 'pointer',
  };

  const userDetailsStore = useStores().userDetailsStore;
  const loginPageStore = useStores().loginPageStore;
  const employerGroupStore = useStores().employerGroupStore;

  const allEmployerGroups = getAllEmployerGroups(
    employerGroupStore.allEmployerGroupsData,
    loginPageStore.employerGroups,
    loginPageStore.isAdmin,
  );

  const userActions = [
    {
      label: 'Delete',
      icon: (
        <SvgDeleteButton
          style={commanIconStyles}
          color={patientAccessTheme.palette.status.icon}
        />
      ),
      onClick: (_index: number) => handleUserDelete(_index),
    },
    {
      label: 'Edit',
      icon: <EditIcon style={commanIconStyles} />,
      onClick: (_index: number) => handleEditUser(_index),
    },
    {
      label: 'Reset Password',
      icon: <Restore style={commanIconStyles} />,
      onClick: (_index: number) => handleResetPassword(_index),
    },
  ];

  const { snackbarState, openSnackbar, handleCloseSnackBar } = useSnackbar();

  const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState<boolean>(
    false,
  );
  const [isTableLoading, setTableLoading] = useState<boolean>(false);
  const [usersPageNumber, setUsersPageNumber] = useState<number>(1);
  const [usersTotalPages, setUsersTotalPages] = useState<number>(0);

  const [usersPageSize] = useState<number>(10);
  const [userData, setUserData] = useState<any[]>([]);
  const [usageData, setUsageData] = useState<any[]>([]);
  const [assignData, setAssignData] = useState<any>({
    firstName: '',
    lastName: '',
    emailID: '',
    role: '',
    user_role: '',
    organization_name: '',
    extractionMethod: '',
    totalGroups: '',
    riskManagement: false,
    riskManagementQuota: '',
    riskManagementScreens: [],
    complianceAssurance: false,
    complianceAssuranceQuota: '',
    complianceAssuranceScreens: [],
    careNavigation: false,
    careNavigationQuota: '',
    careNavigationScreens: [],
    employerGroups: [],
  });
  const [groupsTableRows, setGroupsTableRows] = useState<any[]>([]);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState<boolean>(
    false,
  );
  const [selectedUser, setSelectedUser] = useState<any>({});
  const [searchValue, setSearchValue] = useState<string>('');
  const [openLogsModal, setOpenLogsModal] = useState<boolean>(false);
  const [isLogsLoading, setLogsLoading] = useState<boolean>(false);
  const [logsPageNumber, setLogsPageNumber] = useState<number>(1);
  const [logsTotalPages, setLogsTotalPages] = useState<number>(0);

  const [logsPageSize] = useState<number>(10);
  const [logSearchValue, setLogSearchValue] = useState<string>('');
  const [logsData, setLogsData] = useState<any[]>([]);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    index: number,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };

  const handleUserDelete = (index: number) => {
    const user: any = userData[index];
    if (user) {
      setSelectedUser(user);
      setOpenDeleteModal(true);
    }
  };
  const handleEditUser = (index: number) => {
    const user: any = userData[index];
    if (user) {
      setIsUpdate(true);
      setIsCreateUserModalOpen(true);
      setAssignData({
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        emailID: user.email,
        role: getRoleDisplayName(user.role.name),
        user_role: user.userRole,
        organization_name: user.organizationName,
        extractionMethod: user.extractionMethod,
        totalGroups: user.totalGroups || '',
        riskManagement: user.riskManagement || false,
        riskManagementQuota: user.riskManagementQuota || '',
        riskManagementScreens:
          formatScreensArray(
            user.riskManagementScreens,
            toJS(userDetailsStore.allScreens)?.riskManagement,
          ) || [],
        complianceAssurance: user.complianceAssurance || false,
        complianceAssuranceQuota: user.complianceAssuranceQuota || '',
        complianceAssuranceScreens:
          formatScreensArray(
            user.complianceAssuranceScreens,
            toJS(userDetailsStore.allScreens)?.complianceAssurance,
          ) || [],
        careNavigation: user.careNavigation || false,
        careNavigationQuota: user.careNavigationQuota || '',
        careNavigationScreens:
          formatScreensArray(
            user.careNavigationScreens,
            toJS(userDetailsStore.allScreens)?.careNavigation,
          ) || [],
        employerGroups: user.employerGroups?.map((group: any) => ({
          ...group,
          riskManagementScreens:
            formatScreensArray(
              group.riskManagementScreens,
              toJS(userDetailsStore.allScreens)?.riskManagement,
            ) || [],
          complianceAssuranceScreens:
            formatScreensArray(
              group.complianceAssuranceScreens,
              toJS(userDetailsStore.allScreens)?.complianceAssurance,
            ) || [],
          careNavigationScreens:
            formatScreensArray(
              group.careNavigationScreens,
              toJS(userDetailsStore.allScreens)?.careNavigation,
            ) || [],
          checked: false,
        })),
      });
      setGroupsTableRows(
        user.employerGroups?.map((group: any) => ({
          ...group,
          riskManagementScreens:
            formatScreensArray(
              group.riskManagementScreens,
              toJS(userDetailsStore.allScreens)?.riskManagement,
            ) || [],
          complianceAssuranceScreens:
            formatScreensArray(
              group.complianceAssuranceScreens,
              toJS(userDetailsStore.allScreens)?.complianceAssurance,
            ) || [],
          careNavigationScreens:
            formatScreensArray(
              group.careNavigationScreens,
              toJS(userDetailsStore.allScreens)?.careNavigation,
            ) || [],
          checked: false,
        })),
      );
      setIsAdmin(user.role.name !== 'super_admin');
    }
  };
  const handleResetPassword = (index: number) => {
    const user: any = userData[index];
    if (user) {
      setSelectedUser(user);
      setOpenResetPasswordModal(true);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const handleClose = () => {
    setIsCreateUserModalOpen(false);
    setIsUpdate(false);
  };
  const searchTimeout = useRef<any>(null);

  const handleSearch = (searchTerm: string) => {
    setSearchValue(searchTerm);
    setUsersPageNumber(1);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      getUsersTableData(searchTerm);
    }, 400);
  };

  const handleLogSearch = (searchTerm: string) => {
    setLogSearchValue(searchTerm);
    setLogsPageNumber(1);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      getLogsTableData(searchTerm);
    }, 400);
  };

  const getUsageFormat = (quota: any, usage: any) => {
    return usage ? (
      Number(usage) >= Number(quota) ? (
        <Typography
          fontSize="14px"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.AIQChips?.textColor1}
        >
          {usage}
        </Typography>
      ) : (
        getMediumText(usage)
      )
    ) : (
      getMediumText('-')
    );
  };

  const getMediumText = (text: string) => {
    return (
      <Typography
        fontSize="14px"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {text}
      </Typography>
    );
  };

  const getUserRows = () => {
    const userRows: any = [
      [
        '',
        'First Name',
        'Last Name',
        '',
        '',
        '',
        '',
        '',
        'Quota',
        'Usage',
        getMediumText('Quota'),
        getMediumText('Usage'),
        getMediumText('Quota'),
        getMediumText('Usage'),
      ],
    ];

    userData?.map((item: any, index: number) => {
      const usage: any = usageData?.find(
        (user: any) => user.email === item.email,
      );
      let memberCount: number = 0;
      item?.employerGroups?.map((group: any) => {
        memberCount +=
          toJS(employerGroupStore.allEmployerGroupsData)?.find(
            (data) => data.eg_nid === group.egNid,
          )?.total_enrolles || 0;
      });

      userRows.push([
        <Grid container>
          <IconButton
            style={{ padding: 0 }}
            onClick={(e) => handleMenuClick(e, index)}
            aria-controls="simple-menu"
            aria-haspopup="true"
            size="large"
          >
            <MoreVertIcon
              style={{
                fill: patientAccessTheme.palette.grey[500],
                width: '25px',
                height: '25px',
              }}
            />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl) && selectedRowIndex === index}
            onClose={handleCloseMenu}
            classes={{
              paper: classes.popup,
            }}
          >
            {userActions.map((action) => (
              <MenuItem key={action.label}>
                <TextWithIcon
                  label={action.label}
                  labelClassName={classes.label}
                  startIcon={action.icon}
                  rootStyles={textWithIconStyles}
                  isClickable
                  handleOnClick={() => {
                    if (selectedRowIndex !== null) {
                      action.onClick(selectedRowIndex);
                      handleCloseMenu();
                    }
                  }}
                />
              </MenuItem>
            ))}
          </Menu>
        </Grid>,
        item.firstName,
        item.lastName,
        item.email,
        roleMap(item.role?.name),
        item.userRole || '-',
        item.organizationName || '-',
        item.employerGroups?.length === 0
          ? '-'
          : formatEmployerGroupNameForTable(
              item.employerGroups
                ?.map((group: any) => group.employerName)
                ?.join(','),
              '',
              null,
              true,
              item,
            ),
        item.role?.name === UserAccessConstants.SUPER_ADMIN
          ? 'Unlimited'
          : item.riskManagementQuota,
        item.role?.name === UserAccessConstants.SUPER_ADMIN
          ? 'NA'
          : getUsageFormat(item.riskManagementQuota, memberCount),
        item.role?.name === UserAccessConstants.SUPER_ADMIN
          ? getMediumText('Unlimited')
          : getMediumText(item.complianceAssuranceQuota || '-'),
        item.role?.name === UserAccessConstants.SUPER_ADMIN
          ? getMediumText('NA')
          : getUsageFormat(item.complianceAssuranceQuota, usage?.docs),
        item.role?.name === UserAccessConstants.SUPER_ADMIN
          ? getMediumText('Unlimited')
          : getMediumText(item.careNavigationQuota || '-'),
        item.role?.name === UserAccessConstants.SUPER_ADMIN
          ? getMediumText('NA')
          : getUsageFormat(item.careNavigationQuota, usage?.cases),
      ]);
    });

    return userRows;
  };

  const handleCreateUserNewButton = () => {
    setIsCreateUserModalOpen(true);
    setAssignData({
      firstName: '',
      lastName: '',
      emailID: '',
      role: '',
      extractionMethod: '',
      totalGroups: '',
      riskManagement: false,
      riskManagementQuota: '',
      riskManagementScreens: [],
      complianceAssurance: false,
      complianceAssuranceQuota: '',
      complianceAssuranceScreens: [],
      careNavigation: false,
      careNavigationQuota: '',
      careNavigationScreens: [],
      employerGroups: [],
    });
  };

  const getPayload = () => {
    const payload: any = {};
    payload.firstName = assignData.firstName;
    payload.lastName = assignData.lastName;
    payload.email = assignData.emailID;
    payload.role = {
      name: getRoleValue(assignData.role),
    };
    payload.userRole = assignData.user_role;
    payload.organizationName = assignData.organization_name;
    payload.extractionMethod = assignData.extractionMethod;

    if (assignData.role !== 'Super Admin') {
      payload.totalGroups = Number(assignData.totalGroups);
      payload.riskManagement = assignData.riskManagement;
      payload.riskManagementQuota = Number(assignData.riskManagementQuota);
      payload.riskManagementScreens = assignData.riskManagementScreens
        ?.filter((item: any) => item !== null)
        ?.map((item: any) => item.value);
      payload.complianceAssurance = assignData.complianceAssurance;
      payload.complianceAssuranceQuota = Number(
        assignData.complianceAssuranceQuota,
      );
      payload.complianceAssuranceScreens = assignData.complianceAssuranceScreens
        ?.filter((item: any) => item !== null)
        ?.map((item: any) => item.value);
      payload.careNavigation = assignData.careNavigation;
      payload.careNavigationQuota = Number(assignData.careNavigationQuota);
      payload.careNavigationScreens = assignData.careNavigationScreens
        ?.filter((item: any) => item !== null)
        ?.map((item: any) => item.value);

      payload.employerGroups = [];
      assignData.employerGroups?.map((item: any) => {
        if (
          item.egNid &&
          allEmployerGroups.find((employer) => employer.eg_nid === item.egNid)
        ) {
          payload.employerGroups.push({
            egNid: item.egNid,
            employerName: allEmployerGroups.find(
              (employer) => employer.eg_nid === item.egNid,
            )?.name,
            riskManagement: item.riskManagement,
            riskManagementScreens: item.riskManagementScreens
              ?.filter((item: any) => item !== null)
              ?.map((item: any) => item.value),
            complianceAssurance: item.complianceAssurance,
            complianceAssuranceScreens: item.complianceAssuranceScreens
              ?.filter((item: any) => item !== null)
              ?.map((item: any) => item.value),
            careNavigation: item.careNavigation,
            careNavigationScreens: item.careNavigationScreens
              ?.filter((item: any) => item !== null)
              ?.map((item: any) => item.value),
          });
        }
      });
    }
    return payload;
  };

  const updateUser = async () => {
    if (assignData.id) {
      await axios
        .patch(
          properties.userManagementBaseUrl +
            properties.users +
            '/' +
            assignData.id,
          getPayload(),
        )
        .then((response) => {
          if (response.status === 200) {
            handleClose();
            getUsersTableData('');
          }
        })
        .catch((error) =>
          openSnackbar(error.response?.data?.error, 'error', 6000),
        );
    }
  };

  const deleteUsers = async () => {
    await axios
      .delete(
        properties.userManagementBaseUrl +
          properties.users +
          '/' +
          selectedUser?.id,
      )
      .then((response) => {
        if (response.status === 200) {
          setSelectedUser({});
          setOpenDeleteModal(false);
          openSnackbar('User(s) deleted succesfully', 'success', 6000);
          getUsersTableData('');
        }
      })
      .catch((error) =>
        openSnackbar(error.response?.data?.error, 'error', 6000),
      );
  };

  const sendRegistrationEmail = async () => {
    await axios
      .post(
        properties.userManagementBaseUrl +
          properties.users +
          properties.sendEmail,
        {
          email: assignData.emailID,
          forgotPassword: false,
          redirectUrl: RESET_PASSWORD,
        },
      )
      .catch((error) =>
        openSnackbar(error.response?.data?.error, 'error', 6000),
      );
  };

  const saveUser = async () => {
    await axios
      .post(properties.userManagementBaseUrl + properties.users, getPayload())
      .then((response) => {
        if (response.status === 200) {
          openSnackbar('User added successfully', 'success', 6000);
          setIsCreateUserModalOpen(false);
          sendRegistrationEmail();
          getUsersTableData('');
        }
      })
      .catch((error) =>
        openSnackbar(error.response?.data?.error, 'error', 6000),
      );
  };

  const getUsage = async (emailList: string[]) => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.casesBaseUrl + properties.userUsage,
        {
          emails: emailList,
        },
      )
      .then((res) => {
        setUsageData(res.data.data);
      })
      .catch((error) =>
        openSnackbar(error.response?.data?.error, 'error', 6000),
      );
  };

  const getUsersTableData = async (searchValue: string) => {
    setTableLoading(true);
    if (loginPageStore.isAdmin) {
      await axios
        .get(properties.userManagementBaseUrl + properties.users, {
          params: {
            role: 'admin',
            page: usersPageNumber - 1,
            size: usersPageSize,
            search: searchValue,
          },
        })
        .then((response) => {
          getUsage(response?.data?.users?.map((user: any) => user.email));
          setUserData(response?.data?.users);
          setUsersPageNumber(response?.data?.currentPage + 1);
          setUsersTotalPages(response?.data?.totalPages);
        })
        .catch((error) => {
          openSnackbar(
            error.response?.data?.error ??
              settingsMessages.PAGE.SOMETHING_WENT_WRONG,
            'error',
            8000,
          );
        });
    } else {
      await axios
        .get(properties.userManagementBaseUrl + properties.users, {
          params: {
            page: usersPageNumber - 1,
            size: usersPageSize,
            search: searchValue,
          },
        })
        .then((response) => {
          getUsage(response?.data?.users?.map((user: any) => user.email));
          setUserData(response?.data?.users);
          setUsersPageNumber(response?.data?.currentPage + 1);
          setUsersTotalPages(response?.data?.totalPages);
        })
        .catch((error) => {
          openSnackbar(
            error.response?.data?.error ??
              settingsMessages.PAGE.SOMETHING_WENT_WRONG,
            'error',
            8000,
          );
        });
    }
    setTableLoading(false);
  };

  const getLogsTableData = async (searchValue: string) => {
    setLogsLoading(true);
    if (loginPageStore.userResponse.role.name === 'super_admin') {
      await axios
        .get(
          properties.userManagementBaseUrl +
            properties.users +
            properties.loginHistory,
          {
            params: {
              page: logsPageNumber - 1,
              size: logsPageSize,
              email: searchValue,
            },
          },
        )
        .then((response) => {
          setLogsData(response?.data?.data);
          setLogsPageNumber(response?.data?.currentPage + 1);
          setLogsTotalPages(response?.data?.totalPages);
        })
        .catch((error) => {
          openSnackbar(
            error.response?.data?.error ??
              settingsMessages.PAGE.SOMETHING_WENT_WRONG,
            'error',
            8000,
          );
        });
    }
    setLogsLoading(false);
  };

  const resetUserPassword = async () => {
    await axios
      .post(
        properties.userManagementBaseUrl +
          properties.users +
          properties.sendEmail,
        {
          email: selectedUser?.email,
          forgotPassword: true,
          redirectUrl: RESET_PASSWORD,
        },
      )
      .then(() => {
        setSelectedUser({});
        setOpenResetPasswordModal(false);
        openSnackbar('Reset Password email sent succesfully', 'success', 6000);
      })
      .catch((error) =>
        openSnackbar(error.response?.data?.error, 'error', 6000),
      );
  };

  useEffect(() => {
    getUsersTableData(searchValue);
  }, [usersPageNumber, usersPageSize]);

  useEffect(() => {
    if (openLogsModal) {
      getLogsTableData(logSearchValue);
    }
  }, [logsPageNumber, logsPageSize, openLogsModal]);

  return (
    <>
      <div className={classes.mainDiv}>
        <Box
          style={{
            width: '1182px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <PageTitleAndSubTitle
            title={settingsMessages.PAGE.TITLE}
            subTitle={settingsMessages.PAGE.SUBTITLE}
            customButton={
              loginPageStore?.userResponse?.role?.name !==
              UserAccessConstants.USER
            }
            customButtonText={settingsMessages.PAGE.NEW_USER_BUTTON}
            customButtonClick={handleCreateUserNewButton}
            customButtonWidth="130px"
          />
        </Box>
        <Box
          style={{
            width: '1182px',
          }}
        >
          <CardComponent
            title={settingsMessages.PAGE.TABLE_TITLE}
            subTitle={settingsMessages.PAGE.TABLE_SUBTITLE}
            topRightItem={
              loginPageStore?.userResponse?.role?.name === 'super_admin' ? (
                <DottedText
                  text={settingsMessages.PAGE.USER_LOGS}
                  onClick={() => {
                    setOpenLogsModal(true);
                  }}
                />
              ) : (
                <></>
              )
            }
            width="1182px"
            height="auto"
            padding={'20px 24px 24px 20px'}
            mainGridStyles={{ margin: '23px 0' }}
            body={
              <>
                <TextField
                  placeholder={'Search by First Name, Last Name or Email'}
                  height="44px"
                  startAdornment={
                    <SimpleSearch
                      height="24px"
                      width="24px"
                      stroke={patientAccessTheme.palette.text.lowemphasis}
                    />
                  }
                  value={searchValue}
                  onChange={(event: any) => handleSearch(event.target.value)}
                  showStartAdornment={true}
                  style={{ marginBottom: '1rem', width: '100%' }}
                />

                <Grid className={classes.tableGrid}>
                  <Grid
                    style={{
                      width: '1500px',
                    }}
                  >
                    {isTableLoading ? (
                      <CircularLoader />
                    ) : userData?.length === 0 ? (
                      <NoDataVisual
                        height="620px"
                        width="1580px"
                        content={settingsMessages.PAGE.NO_DATA_CONTENT}
                      />
                    ) : (
                      <Grid className={classes.tabledata}>
                        <BasicTable
                          width="2200px"
                          displayType="box"
                          columns={groupsTableColumns}
                          rowsData={getUserRows()}
                          headerTextColor={
                            patientAccessTheme.palette.status.white
                          }
                          headerColor={patientAccessTheme.palette.grey[700]}
                          borderRadius="4px"
                          showPagination={false}
                        />
                        <Pagination
                          page={usersPageNumber}
                          count={usersTotalPages}
                          onChange={(
                            event: React.ChangeEvent<unknown>,
                            value: number,
                          ) => setUsersPageNumber(value)}
                          size="small"
                          color="primary"
                          style={{
                            margin: '20px 0px',
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </>
            }
          />
        </Box>
      </div>
      <NewUserModal
        open={isCreateUserModalOpen}
        isEdit={isUpdate}
        handleClose={handleClose}
        handleSave={isUpdate ? updateUser : saveUser}
        isSaveButtonDisabled={false}
        userDataState={[assignData, setAssignData]}
        employerGroupState={[groupsTableRows, setGroupsTableRows]}
        isAdminState={[isAdmin, setIsAdmin]}
      />
      {openDeleteModal && (
        <Modal
          open={openDeleteModal}
          onClose={() => {
            setSelectedUser({});
            setOpenDeleteModal(false);
          }}
          className={classes.modal}
        >
          <Paper
            className={classes.paper}
            style={{ width: '517px', height: '318px' }}
          >
            <Grid
              className={classes.upperGrid}
              sx={{
                justifyContent: 'flex-end',
              }}
            >
              <SvgClose
                style={{ cursor: 'pointer' }}
                color={patientAccessTheme.palette.status.icon}
                onClick={() => {
                  setSelectedUser({});
                  setOpenDeleteModal(false);
                }}
              />
            </Grid>

            <Grid
              container
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Grid style={{ marginTop: '0px' }}>
                <img src={DeleteConfirmation} alt="DeleteConfirmation" />
              </Grid>
              <Grid style={{ marginTop: '20px' }}>
                <Typography
                  fontSize="16px"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontType="semiBold"
                >
                  {settingsMessages.PAGE.DELETE_CONFIRMATION_TITLE}
                </Typography>
              </Grid>
              <Grid style={{ marginTop: '5px' }}>
                <Typography
                  fontSize="14px"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                >
                  {settingsMessages.PAGE.DELETE_CONFIRMATION_SUBTITLE}
                </Typography>
              </Grid>

              <Grid style={{ marginTop: '20px' }}>
                <Button
                  label={settingsMessages.PAGE.CONFIRM_DELETE}
                  variant="contained"
                  color="primary"
                  height="33px"
                  width="180px"
                  borderRadius="4px"
                  onClick={deleteUsers}
                />
              </Grid>
            </Grid>
          </Paper>
        </Modal>
      )}
      {openResetPasswordModal && (
        <Modal
          open={openResetPasswordModal}
          onClose={() => {
            setSelectedUser({});
            setOpenResetPasswordModal(false);
          }}
          className={classes.modal}
        >
          <Paper
            className={classes.paper}
            style={{ width: '517px', height: '318px' }}
          >
            <Grid
              className={classes.upperGrid}
              sx={{
                justifyContent: 'flex-end',
              }}
            >
              <SvgClose
                style={{ cursor: 'pointer' }}
                color={patientAccessTheme.palette.status.icon}
                onClick={() => {
                  setSelectedUser({});
                  setOpenResetPasswordModal(false);
                }}
              />
            </Grid>

            <Grid
              container
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Grid style={{ marginTop: '0px' }}>
                <img src={DeleteConfirmation} alt="DeleteConfirmation" />
              </Grid>
              <Grid style={{ marginTop: '20px' }}>
                <Typography
                  fontSize="16px"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontType="semiBold"
                  align="center"
                >
                  {settingsMessages.PAGE.RESET_PASSWORD_CONFIRMATION_TITLE}
                </Typography>
              </Grid>

              <Grid style={{ marginTop: '20px' }}>
                <Button
                  label={settingsMessages.PAGE.CONFIRM_RESET_PASSWORD}
                  variant="contained"
                  color="primary"
                  height="33px"
                  width="auto"
                  borderRadius="4px"
                  onClick={resetUserPassword}
                />
              </Grid>
            </Grid>
          </Paper>
        </Modal>
      )}
      {openLogsModal && (
        <Modal
          open={openLogsModal}
          onClose={() => {
            setOpenLogsModal(false);
          }}
          className={classes.modal}
        >
          <Paper
            className={classes.paper}
            style={{ height: '670px', width: '550px' }}
          >
            <Grid
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            >
              <PageTitleAndSubTitle
                title={settingsMessages.PAGE.USER_LOGS}
                subTitle={''}
                subTitleStyles={{ width: '0px' }}
              />
              <SvgClose
                style={{ cursor: 'pointer', width: '12px', height: '12px' }}
                color={patientAccessTheme.palette.status.icon}
                onClick={() => {
                  setOpenLogsModal(false);
                }}
              />
            </Grid>

            <Grid
              container
              sx={{
                justifyContent: 'flex-start',
                flexDirection: 'column',
              }}
            >
              <Grid>
                <TextField
                  placeholder={'Search by Email'}
                  height="36px"
                  startAdornment={
                    <SimpleSearch
                      height="24px"
                      width="24px"
                      stroke={patientAccessTheme.palette.text.lowemphasis}
                    />
                  }
                  value={logSearchValue}
                  onChange={(event: any) => handleLogSearch(event.target.value)}
                  showStartAdornment={true}
                  style={{ marginBottom: '1rem', width: '100%' }}
                />
              </Grid>
              {isLogsLoading ? (
                <CircularLoader />
              ) : (
                <Grid>
                  <BasicTable
                    displayType="row"
                    columns={[
                      {
                        name: 'Email Id',
                        align: 'left',
                        width: '300px',
                        cellStyles: cellStyles1,
                      },
                      {
                        name: 'Logged In At',
                        align: 'left',
                        width: '300px',
                        cellStyles: cellStyles1,
                      },
                    ]}
                    rowsData={logsData.map((item: any) => {
                      return [item.email, formatDateTime(item.createdAt)];
                    })}
                    cellHeight="40px"
                  />
                  <Pagination
                    page={logsPageNumber}
                    count={logsTotalPages}
                    onChange={(
                      event: React.ChangeEvent<unknown>,
                      value: number,
                    ) => setLogsPageNumber(value)}
                    size="small"
                    color="primary"
                    style={{
                      margin: '15px 0px',
                    }}
                  />
                </Grid>
              )}
              <Grid style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  label={settingsMessages.PAGE.CLOSE}
                  variant="outlined"
                  color="primary"
                  height="33px"
                  width="100px"
                  borderRadius="4px"
                  onClick={() => {
                    setOpenLogsModal(false);
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Modal>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default UserManagementPage;
